import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Globe } from 'lucide-react';
interface SlideCTAProps {
  onContinue: () => void;
}
export function SlideCTA({
  onContinue
}: SlideCTAProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 200);
    const t2 = setTimeout(() => setStage(2), 700);
    const t3 = setTimeout(() => setStage(3), 1400);
    const t4 = setTimeout(() => setStage(4), 2100);
    return () => {
      ;
      [t1, t2, t3, t4].forEach(clearTimeout);
    };
  }, []);
  return <div className="h-full w-full flex items-center justify-center px-8 py-8 md:px-16 md:py-12 bg-white relative overflow-hidden" data-id="element-207">
      {/* Subtle background watermark */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 1 ? 1 : 0
    }} transition={{
      duration: 1.2
    }} className="pointer-events-none absolute inset-0 flex items-center justify-center -mt-32" data-id="element-208">
        <span className="text-[14vw] font-bold tracking-tight text-slate-100 select-none" data-id="element-209">
          snakker
        </span>
      </motion.div>

      <div className="relative z-10 max-w-5xl w-full" data-id="element-210">
        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 1 ? 1 : 0,
        y: stage >= 1 ? 0 : 20
      }} transition={{
        duration: 0.7
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05] text-slate-900" data-id="element-211">
          AI changed campaign economics.
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 2 ? 1 : 0,
        y: stage >= 2 ? 0 : 20
      }} transition={{
        duration: 0.7
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05] mt-1" data-id="element-212">
          <span className="bg-gradient-to-r from-sky-400 via-indigo-400 to-[#6C2BD9] bg-clip-text text-transparent" data-id="element-213">
            Snakker changes what pharma can do with them.
          </span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: stage >= 3 ? 1 : 0,
        y: stage >= 3 ? 0 : 10
      }} transition={{
        duration: 0.6
      }} className="text-lg md:text-2xl text-slate-400 font-medium mt-8" data-id="element-214">
          Unlocking the long tail of pharma growth.
        </motion.p>

        {/* Contact cards */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: stage >= 4 ? 1 : 0,
        y: stage >= 4 ? 0 : 16
      }} transition={{
        duration: 0.6
      }} className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 max-w-3xl" data-id="element-215">
          <a href="mailto:mh@snakker.io" className="group flex items-center gap-4 rounded-2xl py-3 px-2 hover:bg-slate-50 transition-colors" data-id="element-216">
            <div className="w-12 h-12 rounded-full bg-[#F5F0FF] flex items-center justify-center text-[#6C2BD9] flex-shrink-0 group-hover:scale-105 transition-transform" data-id="element-217">
              <Mail className="w-5 h-5" data-id="element-218" />
            </div>
            <div className="text-left" data-id="element-219">
              <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-bold" data-id="element-220">
                Contact
              </p>
              <p className="text-base md:text-lg font-bold text-slate-900 mt-0.5" data-id="element-221">
                Morten Hjelmsø · mh@snakker.io
              </p>
            </div>
          </a>

          <a href="https://www.snakker.io" target="_blank" rel="noreferrer" className="group flex items-center gap-4 rounded-2xl py-3 px-2 hover:bg-slate-50 transition-colors" data-id="element-222">
            <div className="w-12 h-12 rounded-full bg-[#F5F0FF] flex items-center justify-center text-[#6C2BD9] flex-shrink-0 group-hover:scale-105 transition-transform" data-id="element-223">
              <Globe className="w-5 h-5" data-id="element-224" />
            </div>
            <div className="text-left" data-id="element-225">
              <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-bold" data-id="element-226">
                Visit
              </p>
              <p className="text-base md:text-lg font-bold text-slate-900 mt-0.5" data-id="element-227">
                www.snakker.io
              </p>
            </div>
          </a>
        </motion.div>
      </div>
    </div>;
}